// register globally
// eslint-disable-next-line import/no-unresolved
import Vue from 'vue';
import infiniteScroll from 'vue-infinite-scroll';

Vue.use(infiniteScroll);



// WEBPACK FOOTER //
// ./src/plugins/vue-infinite-scroll.js